import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const StepConnectorIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="">
      <line
        y2="0"
        x2="100%"
        y1="0"
        x1="0"
        fill="none"
        stroke={props.color ? props.color : theme.palette.black.light}
        strokeLinecap="round"
        strokeWidth="2"
        strokeDasharray="1 4"
      />
    </SvgIcon>
  );
};
